module.exports = __webpack_public_path__ + "img/jcb.b7f84708.svg";